import React, { useEffect } from "react";
import { usePortalAuthentication } from "../../services/authorizationService";

export const SessionLost = () => {
    const { login } = usePortalAuthentication();

    useEffect(() => {
        login();
    }, []);
    return (<div className="loading"></div>);
};